import React, { useMemo } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { dynamicPagination } from '../../../../../utils/common/dynamicPagination';
import {
    selectSelected,
    setSelectedRows,
} from '../../../../common/store/selectionSlice';
import { getColumns } from '../utils/getColumns';
import {
    CommonFiltersProps,
    CommonTableProps,
} from '../../../interfaces/common.interface';
import { BroadcastProps } from '../service/broadcasts.interface';

export const MassBroadcastsTable = (
    props: CommonTableProps<BroadcastProps, CommonFiltersProps>
) => {
    const { source, loading, filters, updateFilters, getColumnSearchProps } =
        props;

    const navigate = useNavigate();

    const pagination = useMemo(
        () =>
            dynamicPagination(
                filters,
                updateFilters,
                source?.total,
                'Рассылок'
            ),
        [filters, updateFilters, source?.total]
    );

    const dispatch = useDispatch();
    const { selectedRows } = useSelector(selectSelected);

    const rowSelection = {
        selectedRowKeys: selectedRows,
        onChange: (keys: React.Key[]) => {
            dispatch(setSelectedRows(keys as number[]));
        },
    };

    const viewBroadcast = (id: number) => {
        return navigate(`${id}`);
    };

    return (
        <Table
            rowSelection={rowSelection}
            loading={loading}
            pagination={pagination}
            dataSource={source?.items}
            rowKey={record => record.id}
            columns={getColumns(
                getColumnSearchProps,
                updateFilters,
                viewBroadcast
            )}
        />
    );
};
